module.exports = __webpack_public_path__ + "img/lb_menu_bg_a_1.8aaffab9.png";